export class PrescriptionModel {
    public id: string;
    public prescriptionName: string;
    public description: string;
    public brandName: string;
    public sig: string;
    public note: string;
    public defaultDose: string;
    public weekQuantity: any = null;
    public defunct: any = 0;
    public priority: number = 0;
    public prescriptionCategoryName: string;
    public centreIds: string[];
    public prescriptionId: string;
}

export enum WeekQuantityType {
    Quantity = 0,
    Week = 1
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/master-data/prescription.model.ts